"use client";

import { GradientText } from "@/components/ui/gradient-text";
import { Card } from "@/components/ui/card";
import { AlertTriangle, Clock, DollarSign, Headphones } from "lucide-react";

const problems = [
  {
    icon: Clock,
    title: "Miss Out on Rare Tracks",
    description: "Without real-time notifications, you'll be late to every leak, missing the chance to hear exclusive versions that might get taken down."
  },
  {
    icon: DollarSign,
    title: "Waste Money on Fakes",
    description: "Get scammed buying fake leaks from unverified sources, wasting money on low-quality or non-existent tracks."
  },
  {
    icon: AlertTriangle,
    title: "Download Corrupted Files",
    description: "Risk your device's security downloading from sketchy websites, potentially getting malware instead of music."
  },
  {
    icon: Headphones,
    title: "Listen to Poor Quality",
    description: "Settle for low bitrate recordings and poorly mixed versions when better quality leaks are available elsewhere."
  }
];

export function ProblemSection() {
  return (
    <section className="py-16 px-4 relative overflow-hidden" id="problems">
      <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:32px]" />
      
      <div className="container mx-auto max-w-6xl relative">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            <GradientText>Don't Get Left Behind</GradientText>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Missing out on underground leaks means falling behind the culture. Here's what happens when you're not in the loop:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <Card key={index} className="p-6 bg-muted/50 border-muted-foreground/20 hover:border-primary/50 transition-all duration-300">
              <div className="relative w-fit mb-4">
                <div className="absolute -inset-2 bg-gradient-to-r from-red-500 to-purple-600 rounded-full blur opacity-40" />
                <problem.icon className="h-10 w-10 text-red-500 relative" />
              </div>
              <h3 className="text-xl font-semibold mb-3">{problem.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{problem.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}